module.exports = new __parcel__URL__("rare_pack_icon.83c1cab9.png").toString();